import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { store } from "./store";
import {
  ApplicableCoupon,
  ApplicableCouponsApiResponse,
  ApplicableCouponsHeaders,
  ApplicableCouponsParams,
} from "../models/Coupons";

export default class CouponStore {
  applicableCoupons: ApplicableCoupon[] = [];
  applicableCouponsCount: number = 0;
  loadingApplicableCoupons: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  /*------------------ Applicable Coupons ------------------*/
  get getLoadingApplicableCoupons() {
    return this.loadingApplicableCoupons;
  }

  fetchApplicableCoupons = async (
    params: ApplicableCouponsParams,
    headers: ApplicableCouponsHeaders
  ) => {
    this.loadingApplicableCoupons = true;
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("deliveryType", String(params.deliveryType));
      queryParams.append(
        "warehouseId",
        String(
          store.commonStore.warehouseId ?? params.warehouseId
        )
      );

      const result: ApplicableCouponsApiResponse =
        await agent.Cart.fetchApplicableCoupons(queryParams, headers);

      runInAction(() => {
        this.applicableCoupons = result.data ?? [];
        this.applicableCouponsCount = result.count ?? 0;
      });
    } catch (error) {
      console.error("Error fetching applicable coupons:", error);
      runInAction(() => {
        this.applicableCoupons = [];
        this.applicableCouponsCount = 0;
      });
    } finally {
      runInAction(() => {
        this.loadingApplicableCoupons = false;
      });
    }
  };

  /*------------------ Helpers ------------------*/
  get unlockedCoupons() {
    return this.applicableCoupons.filter((c) => c.isApplicable);
  }

  get lockedCoupons() {
    return this.applicableCoupons.filter((c) => !c.isApplicable);
  }

  clearCoupons = () => {
    this.applicableCoupons = [];
    this.applicableCouponsCount = 0;
  };
}